export const embedded = (): boolean => window.self !== window.top;
